import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, CloudIcon, RocketIcon, LayersIcon } from 'lucide-react';
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function SolutionSlide() {
  return <motion.div className="w-full h-full flex flex-col px-12 py-10" variants={stagger} initial="hidden" animate="visible" data-id="element-315">
      <motion.div variants={fadeUp} className="flex items-center gap-3 mb-2" data-id="element-316">
        <span className="text-base text-[#00d4ff] font-semibold tracking-widest uppercase" data-id="element-317">
          03
        </span>
        <span className="w-8 h-[1px] bg-[#00d4ff] opacity-50" data-id="element-318" />
      </motion.div>

      <motion.h2 variants={fadeUp} className="text-4xl md:text-5xl font-extrabold text-white mb-3" data-id="element-319">
        Solution
      </motion.h2>

      <motion.p variants={fadeUp} className="text-2xl text-[#00d4ff] font-semibold mb-8 max-w-3xl" data-id="element-320">
        Cloud FPGA Inference Gateway: Pay per FPGA token, zero hardware hassle
      </motion.p>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-321">
        <motion.div variants={fadeUp} className="glass-card p-6 flex gap-4 items-start" data-id="element-322">
          <div className="w-10 h-10 rounded-lg bg-[rgba(0,212,255,0.1)] flex items-center justify-center flex-shrink-0" data-id="element-323">
            <LayersIcon className="w-5 h-5 text-[#00d4ff]" data-id="element-324" />
          </div>
          <div data-id="element-325">
            <p className="text-[20px] text-white/90 leading-relaxed" data-id="element-326">
              We are OpenRouter for FPGAs. Our API abstracts server hardware.
              Push button, get inference.
            </p>
          </div>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-6 flex gap-4 items-start" data-id="element-327">
          <div className="w-10 h-10 rounded-lg bg-[rgba(255,107,53,0.1)] flex items-center justify-center flex-shrink-0" data-id="element-328">
            <ZapIcon className="w-5 h-5 text-[#ff6b35]" data-id="element-329" />
          </div>
          <div data-id="element-330">
            <p className="text-[20px] text-white/90 leading-relaxed" data-id="element-331">
              Users choose:{' '}
              <span className="text-[#ff6b35] font-semibold" data-id="element-332">
                2-10X Cheaper
              </span>{' '}
              or{' '}
              <span className="text-[#00d4ff] font-semibold" data-id="element-333">2-5X faster</span>{' '}
              than GPU tokens/$.
            </p>
          </div>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-6 flex gap-4 items-start" data-id="element-334">
          <div className="w-10 h-10 rounded-lg bg-[rgba(0,212,255,0.1)] flex items-center justify-center flex-shrink-0" data-id="element-335">
            <RocketIcon className="w-5 h-5 text-[#00d4ff]" data-id="element-336" />
          </div>
          <div data-id="element-337">
            <p className="text-[20px] text-white/90 leading-relaxed" data-id="element-338">
              Deploy in minutes instead of months; scales elastically like any
              cloud service
            </p>
          </div>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-6 flex gap-4 items-start glow-cyan" data-id="element-339">
          <div className="w-10 h-10 rounded-lg bg-[rgba(0,212,255,0.1)] flex items-center justify-center flex-shrink-0" data-id="element-340">
            <CloudIcon className="w-5 h-5 text-[#00d4ff]" data-id="element-341" />
          </div>
          <div data-id="element-342">
            <p className="text-[20px] text-white/90 leading-relaxed" data-id="element-343">
              First true "
              <span className="text-[#00d4ff] font-semibold" data-id="element-344">
                FPGA-as-a-Service
              </span>
              " for AI inference
            </p>
          </div>
        </motion.div>
      </div>
    </motion.div>;
}